export const SKIP_SECONDS = 10

export const QualitySettings = [
  {
    type: "SMALL_360P",
    text: "Laag (8mb / 360p)",
    subText: "Gebruik bij traag internet",
  },
  {
    type: "MEDIUM_720P",
    text: "Gemiddeld (21mb / 720p)",
    subText: "Gemiddelde internet snelheid",
  },
  {
    type: "LARGE_1080P",
    text: "Hoog (40mb / 1080p)",
    subText: "Snel internet",
  },
]

export type PlaybackSpeedType = "NORMAL" | "SLOW" | "SLOWER" | "CUSTOM"

export const PlaybackSettings = [
  { type: "NORMAL", text: "Normaal 100%", value: 1 },
  { type: "SLOW", text: "Langzaam 90%", value: 0.9 },
  { type: "SLOWER", text: "Traag 80%", value: 0.8 },
  // { type: "CUSTOM", text: "Zelf-instelbare afspeelsnelheid", chevron: true },
]
